import React, { useEffect, useRef, useState } from "react";
import "./RangeSelector.css";
import { useLanguage } from "../../../../LanguageProvider";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import DatePicker from "../../../../components/DatePicker/DatePicker";
export default function RangeSelector({
  selectedRange,
  setSelectedRange,
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
  fetchDatas,
}) {
  const { getTranslation } = useLanguage();
  const options = [
    {
      value: "today",
      label: getTranslation("today"),
    },
    {
      value: "last7Days",
      label: getTranslation("7days"),
    },
    {
      value: "last30Days",
      label: getTranslation("30days"),
    },
    {
      value: "last365Days",
      label: getTranslation("365days"),
    },

    {
      value: "inBetween",
      label: getTranslation("customRange"),
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleSelectType = (e) => {
    const value = e.target.value;
    setSelectedRange(value);

    if (value === "today") {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      const formattedToday = `${day}-${month}-${year}`;

      setSelectedStartDate(formattedToday);
      setSelectedEndDate(formattedToday);

      // fetchDatas("inBetween");
    } else if (value !== "inBetween") {
      fetchDatas(value);
      setSelectedStartDate("");
      setSelectedEndDate("");
    }
  };

  return (
    <div className="date-range-selector">
      <p className="date-range-selector-title">
        {getTranslation("dateFilter")}
      </p>

      <div className="custom-range-container">
        <Dropdown
          style={{ width: "160px" }}
          options={options}
          onChange={handleSelectType}
          value={selectedRange}
        />
        {selectedRange === "inBetween" && (
          <div className="date-range-selector-holder">
            <DatePicker
              onDateSelect={(date) => setSelectedStartDate(formatDate(date))}
              toggleLabel={getTranslation("startDate")}
              buttonStyle={{ width: "200px" }}
            />
            <DatePicker
              onDateSelect={(date) => setSelectedEndDate(formatDate(date))}
              toggleLabel={getTranslation("endDate")}
              buttonStyle={{ width: "200px" }}
            />

            <button
              onClick={() => fetchDatas("inBetween")}
              className="kronos-add-manual-button"
            >
              {getTranslation("search")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
